import React from "react";
import classNames from "classnames";
import { FormSelect as Select } from "@jsq/ds/forms";
import { capitalizeEachWord } from "../../utils";
import { UsStates } from "./constants";
import * as styles from "./styles_vanilla.css";

type Props = {
  name: string;
  className?: string;
  isFull?: boolean;
  placeholder?: string;
  label?: string;
};

export const StateSelectDropdown: React.FunctionComponent<Props> = ({
  name,
  className = undefined,
  isFull = true,
  placeholder = "Select a state",
  label = undefined,
}) => {
  return (
    <Select
      name={name}
      full={isFull}
      placeholder={placeholder}
      className={classNames(styles.stateSelection, className)}
      data-cy={name}
      data-testid={name}
      label={label}
    >
      <Select.Section>
        {UsStates.map((state) => (
          <Select.Option key={state.code} value={state.code.toUpperCase()}>
            {capitalizeEachWord(state.name)}
          </Select.Option>
        ))}
      </Select.Section>
    </Select>
  );
};
